module.exports = "https://web-assets.ifttt.com/packs/media/onboarding/selector_helper-116f17e8.png";